export default {
  en: {
    unanswered: 'Unanswered',
    notApplicable: 'Not applicable',
    invalid: 'Invalid',
    unknown: 'Unknown',
    selectionCount: '{n} selection | {n} selections',
    notRequired: 'Not required',
    policyRequirement: '{n} selection in allow list | {n} selections in allow list',
    requireOnly: 'Require only',
    policyPlaceholder: 'Search for countries to add',
    outOfScope: 'Out of scope',
    lastModified: 'Last modified {0}',
    selectPlaceholder: 'Search for countries to add',
    emptyTitle: 'No countries selected',
    emptySubTitle: 'Use the dropdown to add some',
    addNotes: 'Add notes...',
    errors: {
      emptyMultiselect: 'Requires at least one field to be selected.',
    },
  },
};
